import { createSelector } from 'reselect'

const getLesson = (state, props) => state.lessons && state.lessons[props.entityUID] ? state.lessons[props.entityUID] : null

const myLibraryLessonSelector = createSelector(
	[getLesson],
	lesson => lesson
)

export default myLibraryLessonSelector
